import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { PitFinancingItem } from "./pit-financing-item";
import { DxCoreUtils } from "../../dx-core/utiles/dx-core-utils";
import { DxGridRow } from "../../dx-grid/domain/dx-grid-row";
/** Финансирование по источникам */
let PitActivityFinancingAmountBySource = class PitActivityFinancingAmountBySource extends DxGridRow {
    /** Финансирование по источникам */
    constructor() {
        super(...arguments);
        /** Сумма резерва */
        this.reserveAmount = 0;
        this.donorRows = [];
        this._fakeId = DxCoreUtils.randomHexaDecimal();
    }
    get financingItemId() {
        return this._financingItemId ? this._financingItemId : (this.financingItem ? this.financingItem.id : null);
    }
    get isNew() {
        return this.id !== this._id;
    }
    get id() {
        return this._id ? this._id : this._fakeId;
    }
    set id(value) {
        this._id = value;
    }
    getRowId() {
        return this.id;
    }
    set financingItemId(value) {
        this._financingItemId = value;
    }
    get budgetLevel() {
        return this.financingItem.budgetLevelId === 1 ? 'Региональный' : 'Федеральный';
    }
    get normType() {
        return this.financingItem.normTypeId === 1 ? 'Норматив' : 'Сверхнорматив';
    }
    get overrunSum() {
        return this.value - this.limitRestAmount;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmountBySource.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmountBySource.prototype, "year", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: PitFinancingItem, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitFinancingItem)
], PitActivityFinancingAmountBySource.prototype, "financingItem", void 0);
tslib_1.__decorate([
    jsonMember({ name: 'financingItemId', constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number),
    tslib_1.__metadata("design:paramtypes", [Number])
], PitActivityFinancingAmountBySource.prototype, "financingItemId", null);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmountBySource.prototype, "limitAmount", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmountBySource.prototype, "limitRestAmount", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmountBySource.prototype, "reserveAmount", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmountBySource.prototype, "financingSum", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityFinancingAmountBySource.prototype, "value", void 0);
PitActivityFinancingAmountBySource = tslib_1.__decorate([
    jsonObject
], PitActivityFinancingAmountBySource);
export { PitActivityFinancingAmountBySource };
